export const images = {
  logo: require("../assets/images/groople_new_logo.png"),
  loginLogo: require("../assets/images/groople_new_logo.jpg"),
  cloudySky: require("../assets/images/cloudy-sky-dawn-1.png"),
  SingleBookingHero: require("../assets/images/hero-single-booking-bg.jpg"),
  GroupBookingHero: require("../assets/images/hero-group-booking-bg.jpg"),
};
export const groups = {
  university: require("../assets/images/group-travel/university.jpg"),
  church: require("../assets/images/group-travel/church.jpg"),
  corporate: require("../assets/images/group-travel/corporate.jpg"),
  school: require("../assets/images/group-travel/school.jpg"),
  team: require("../assets/images/group-travel/sports.jpg"),
  air: require("../assets/images/group-travel/air.jpg"),
};
export const blog = {
  hero: require("../assets/images/blog/hero-bg.jpg"),
  featured: require("../assets/images/blog/featured.jpg"),
  avatar: require("../assets/images/blog/john-butler-avatar.png"),
  verified: require("../assets/images/blog/verified.svg"),
  popular01: require("../assets/images/blog/popular-01.jpg"),
  popular02: require("../assets/images/blog/popular-02.jpg"),
  recent01: require("../assets/images/blog/recent-01.jpg"),
  recent02: require("../assets/images/blog/recent-02.jpg"),
  recent03: require("../assets/images/blog/recent-03.jpg"),
};
export const IconsUrl =
  process.env.REACT_APP_ICON_URL + "images/amenities/icons/";
export const ImageGif = {
  hotelLoader: require("../assets/images/hotel-loader.gif"),
};
export const ImagePng = {
  guest: require("../assets/images/Mask-group-18.png"),

  //Top review dummy image
  topReviewDummy: require("../assets/images/topReviewDummy.png"),

  // TrustedTraveler
  IndividualRectangle: require("../assets/images/Rectangle-449.png"),
  GroupRectangle: require("../assets/images/Rectangle-450.png"),
  CorporateRectangle: require("../assets/images/Rectangle-440.png"),
  FamilyRectangle: require("../assets/images/Rectangle-448.png"),

  // country images
  DALLAS: require("../assets/images/DALLAS.png"),
  AUSTIN: require("../assets/images/AUSTIN.png"),
  HOUSTON: require("../assets/images/HOUSTON.png"),
  WASHINGTONDC_1: require("../assets/images/WASHINGTON-DC_1.png"),
  PHILADELPHIA: require("../assets/images/PHILADELPHIA.png"),
  MIAMI: require("../assets/images/MIAMI.png"),
  BROKLYN: require("../assets/images/BROKLYN.png"),
  CHICAGO: require("../assets/images/Chicago.png"),
  Cleveland: require("../assets/images/Cleveland.png"),
  LosAngeles: require("../assets/images/Los-Angeles.png"),
  LasVegas: require("../assets/images/Las-Vegas.png"),
  Boston: require("../assets/images/Boston.png"),

  // Popular Sport
  SportImage1: require("../assets/images/Dallas-Mavericks.png"),
  SportImage2: require("../assets/images/American-Baseball.png"),
  SportImage3: require("../assets/images/volleyball.png"),
  SportImage4: require("../assets/images/woman-soccer.png"),
  SportImage5: require("../assets/images/American-Footeball.png"),
  SportImage6: require("../assets/images/Lacrosse.png"),
  SportImage7: require("../assets/images/Bowling.png"),
  SportImage8: require("../assets/images/Golf.png"),
  SportImage9: require("../assets/images/Stunt.png"),
  SportImage10: require("../assets/images/Track.png"),
  SportImage11: require("../assets/images/Houston-SaberCats.png"),

  //Popular geta
  Images1: require("../assets/images/Rectangle-451.png"),
  Images2: require("../assets/images/Rectangle-452.png"),
  Images3: require("../assets/images/Rectangle-453.png"),
  Images4: require("../assets/images/Rectangle-454.png"),

  // Travel Blog

  TravelImages1: require("../assets/images/Rectangle-121.png"),
  TravelImages2: require("../assets/images/Rectangle-122.png"),
  TravelImages3: require("../assets/images/Rectangle-123.png"),

  // GroopleProvider

  GroupImages1: require("../assets/images/Group-76.png"),

  //social icon
  Facebook: require("../assets/images/facebook_.png"),
  Twitter: require("../assets/images/twitter_logo.png"),
  Linkedin: require("../assets/images/linkedin_.png"),

  FooterImages: require("../assets/images/Group-103.png"),

  //hotel Image
  HotelImage: require("../assets/images/image-2.png"),
  // Group Booking Icons
  AcceptedIcon: require("../assets/images/accepted_icon.png"),
  DeclinedByCustomerIcon: require("../assets/images/customer_declined.png"),
  DeclinedByHotelIcon: require("../assets/images/HotelDeclined.png"),
  PaymentReceivedIcon: require("../assets/images/payment recieved.png"),
  WaitingResponseIcon: require("../assets/images/waiting_for_response_icon.png"),
  InprogressIcon: require("../assets/images/inprogress_icon.png"),
  // GroupType

  College: require("../assets/images/college.png"),
  Religious: require("../assets/images/religous.png"),
  Corporate: require("../assets/images/corporate.png"),
  Teens: require("../assets/images/Teens.png"),
  Sports: require("../assets/images/sports.png"),

  // about us
  Rectangle1: require("../assets/images/Depositphotos_162340260_L.jpg"),
  deposit: require("../assets/images/Depositphotos_77167553_L.jpg"),
  Rectangle2: require("../assets/images/man-laptop.png"),
  Rectangle3: require("../assets/images/Depositphotos_72522257_XL-min.jpg"),

  //Top Destination

  WashingtonGetaways: require("../assets/images/Washington-DC.png"),
  SanFrancisco: require("../assets/images/image-asset-6.png"),
  Orlando: require("../assets/images/image-15-1.png"),
  NewYork: require("../assets/images/image-14-1.png"),
  NewOrleans: require("../assets/images/New-Orleans-LA.png"),
  Atlanta: require("../assets/images/Atlanta-GA.png"),
  LasVegasGetaways: require("../assets/images/Las-Vegas-NV_1.png"),
  Chicago: require("../assets/images/Chicago-IL.png"),

  // AtlantaPage

  AtlantaPage: require("../assets/images/atlanta-4.jpg"),
  AtlantaPage1: require("../assets/images/atlanta-5.jpg"),
  AtlantaPage2: require("../assets/images/atlanta-2.jpg"),
  AtlantaPage3: require("../assets/images/atlanta-3.jpg"),
  AtlantaPage4: require("../assets/images/atlanta-1.jpg"),
  AtlantaPage5: require("../assets/images/Screenshot-2023-05-03-045908.png"),
  AtlantaPage6: require("../assets/images/atlanta-6.jpg"),

  // ChicagoPage

  ChicagoPage: require("../assets/images/chicago-1.jpg"),
  ChicagoPage1: require("../assets/images/chicago-6.jpg"),
  ChicagoPage2: require("../assets/images/chicago-3.jpg"),
  ChicagoPage3: require("../assets/images/chicago-2.jpg"),
  ChicagoPage4: require("../assets/images/chicago-4.jpg"),
  ChicagoPage5: require("../assets/images/chicago-5.jpg"),
  ChicagoPage6: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // LasVegasPage

  LasVegasPage: require("../assets/images/las-vegas-6.jpg"),
  LasVegasPage2: require("../assets/images/las-vegas-2.jpg"),
  LasVegasPage3: require("../assets/images/las-vegas-5.jpg"),
  LasVegasPage4: require("../assets/images/las-vegas-1.jpg"),
  LasVegasPage5: require("../assets/images/las-vegas-3.jpg"),
  LasVegasPage6: require("../assets/images/las-vegas-4.jpg"),
  LasVegasPage7: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // NewOrleansPage

  NewOrleansPage: require("../assets/images/new-orleans-3.jpg"),
  NewOrleansPage1: require("../assets/images/new-orleans-6.jpg"),
  NewOrleansPage2: require("../assets/images/new-orleans-2.jpg"),
  NewOrleansPage3: require("../assets/images/new-orleans-1.jpg"),
  NewOrleansPage4: require("../assets/images/new-orleans-5.jpg"),
  NewOrleansPage5: require("../assets/images/new-orleans-4.jpg"),
  NewOrleansPage6: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // NewYorkPage

  NewYorkPage: require("../assets/images/new-york-5.jpg"),
  NewYorkPage1: require("../assets/images/new-york-1.jpg"),
  NewYorkPage2: require("../assets/images/new-york-6.jpg"),
  NewYorkPage3: require("../assets/images/new-york-3.jpg"),
  NewYorkPage4: require("../assets/images/new-york-4.jpg"),
  NewYorkPage5: require("../assets/images/new-york-2.jpg"),
  NewYorkPage6: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // OrlandoPage

  OrlandoPage: require("../assets/images/orlando-7.jpg"),
  OrlandoPage1: require("../assets/images/orlando-2.jpg"),
  OrlandoPage2: require("../assets/images/orlando-3.jpg"),
  OrlandoPage3: require("../assets/images/orlando-4.jpg"),
  OrlandoPage4: require("../assets/images/orlando-6.jpg"),
  OrlandoPage5: require("../assets/images/orlando-1.jpg"),
  OrlandoPage6: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // SanFranciscoPage

  SanFranciscoPage: require("../assets/images/san-franscisco-3.jpg"),
  SanFranciscoPage1: require("../assets/images/san-franscisco-4.jpg"),
  SanFranciscoPage2: require("../assets/images/san-franscisco-5.jpg"),
  SanFranciscoPage3: require("../assets/images/san-franscisco-2.jpg"),
  SanFranciscoPage4: require("../assets/images/san-franscisco-1.jpg"),
  SanFranciscoPage5: require("../assets/images/san-franscisco-7.jpg"),
  SanFranciscoPage6: require("../assets/images/san-franscisco-6.jpg"),
  SanFranciscoPage7: require("../assets/images/san-franscisco-8.jpg"),
  SanFranciscoPage8: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // WashingtonGetaways

  WashingtonDcPage: require("../assets/images/Washinton-DC.png"),
  WashingtonDcPage1: require("../assets/images/217726624.png"),
  WashingtonDcPage2: require("../assets/images/132877976.png"),
  WashingtonDcPage3: require("../assets/images/123155698.png"),
  WashingtonDcPage4: require("../assets/images/98216938.png"),
  WashingtonDcPage5: require("../assets/images/rock-creeck.png"),
  WashingtonDcPage6: require("../assets/images/70906285.png"),
  WashingtonDcPage7: require("../assets/images/Screenshot-2023-05-03-045908.png"),

  // location icon
  LocationIcon: require("../assets/images/pin-Icon.png"),

  // College Group
  CollegePage: require("../assets/images/beautiful-caucasian-girls-are-ordering-daily-specials-from-menu-terrace-cafe.jpg"),
  CollegePage1: require("../assets/images/friends-unpack-luggage-listen-music.jpg"),
  CollegePage2: require("../assets/images/female-traveler-with-flowers-camera.jpg"),

  CollegeTopDestination: require("../assets/images/Cancun-Mexico.png"),
  CollegeTopDestination1: require("../assets/images/Tampa-Florida.png"),
  CollegeTopDestination2: require("../assets/images/South-Beach-FL.png"),
  CollegeTopDestination3: require("../assets/images/Lake-Tahoe-CA.png"),
  CollegeTopDestination4: require("../assets/images/Myrtle-Beach-SC.png"),
  CollegeTopDestination5: require("../assets/images/Los-Angeles-CA.png"),

  // Corporate Group

  CorporatePage: require("../assets/images/diverse-business-people-dinner-party.jpg"),
  CorporatePage1: require("../assets/images/medium-shot-people-with-wine-glasses.jpg"),
  CorporatePage2: require("../assets/images/brainstorming-session.jpg"),

  CorporateTopDestination: require("../assets/images/Las-Vegas-NV.png"),
  CorporateTopDestination1: require("../assets/images/Puerto-Rico.png"),
  CorporateTopDestination2: require("../assets/images/Maui-HI.png"),
  CorporateTopDestination3: require("../assets/images/Dominican-Republic.png"),
  CorporateTopDestination4: require("../assets/images/Miami-FL.png"),
  CorporateTopDestination5: require("../assets/images/Dallas---Ft.-Worth.png"),

  // Religious Group

  ReligiousPage: require("../assets/images/multiethnic-students-studying-library.jpg"),

  ReligiousTopDestination: require("../assets/images/Orlando-FL-Church.png"),
  ReligiousTopDestination1: require("../assets/images/Atlanta-GA-urban.png"),
  ReligiousTopDestination2: require("../assets/images/Toronto-Canada-homes.png"),
  ReligiousTopDestination3: require("../assets/images/Mexico-Going-South.png"),
  ReligiousTopDestination4: require("../assets/images/San-Antonio-TX-fellowship.png"),

  // School Group

  SchoolPage: require("../assets/images/happy-kids-playing.jpg"),
  SchoolPage1: require("../assets/images/students-having-lunch-canteen.jpg"),
  SchoolPage2: require("../assets/images/children-board-sea-yacht-teen-child-girls-outdoor.jpg"),
  SchoolPage3: require("../assets/images/group-children-are-lined-up-front-water-slide.jpg"),

  SchoolTopDestination: require("../assets/images/Las-Vegas-NV.png"),
  SchoolTopDestination1: require("../assets/images/Puerto-Rico.png"),
  SchoolTopDestination2: require("../assets/images/Maui-HI.png"),
  SchoolTopDestination3: require("../assets/images/Dominican-Republic.png"),
  SchoolTopDestination4: require("../assets/images/Miami-FL.png"),
  SchoolTopDestination5: require("../assets/images/Dallas---Ft.-Worth.png"),

  // Sport Group

  SportPage: require("../assets/images/men-playing-rugby-field.jpg"),
  SportPage1: require("../assets/images/group-people-with-black-color-skin-putting-hands-together.jpg"),
  SportPage2: require("../assets/images/active-young-people-playing-squash.jpg"),

  SportTopDestination: require("../assets/images/Orlanda-Florida.png"),
  SportTopDestination1: require("../assets/images/Cooperstown-New-York.png"),
  SportTopDestination2: require("../assets/images/Colorado-Springs-Colorado.png"),
  SportTopDestination3: require("../assets/images/San-Diego-California.png"),
  SportTopDestination4: require("../assets/images/Indianapolis-Indiana.png"),
};
